var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},_vm._l((_vm.data),function(item){return _c('el-tab-pane',{key:item.k,attrs:{"lazy":true,"label":item.k,"name":item.k}},[_c('Java',{attrs:{"value":item.v,"height":"600px"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }